import mushroom from 'pmcc-api';
import { blockUi, unblockUi } from '../shared/utils';
import SharedAuthService from './SharedAuthService';

window.requestCount = 0;

// đăng nhập
let AuthService = {};

AuthService.login = (account, password, remember) => {
  blockUi();
  return mushroom.$auth.loginAsync(account, password, remember)
    .then(response => {
      SharedAuthService.syncCurrentLocalTokenToCookie(remember);
      unblockUi();
      return response;
    })
    .catch(error => {
      unblockUi();
      throw error;
    });
};

// đăng xuất
AuthService.logout = (logoutMode) => {
  blockUi();
  return mushroom.$auth.logoutAsync({
    mode: logoutMode
  })
    .then(response => {
      SharedAuthService.clearSharedAuth();
      unblockUi();
      return response;
    })
    .catch(error => {
      SharedAuthService.clearSharedAuth();
      unblockUi();
      throw error;
    });
};

// Kiểm tra trạng thái đăng nhập
AuthService.status = () => {
  return mushroom.$auth.statusAsync()
    .then(response => {
      return response.result;
    })
    .catch(error => {
      throw error;
    });
};

// Lấy về thông tin người dùng hiện tại
AuthService.me = () => {
  return mushroom.$auth.meAsync()
    .then(response => {
      return response;
    })
    .catch(error => {
      throw error;
    });
};

// đăng ký
AuthService.register = (account, password) => {
  return mushroom.$auth.registerAsync(account, password)
    .then(response => {
      if (response.requireActivation) {
      }
      else {
      }
      return response;
    })
    .catch(error => {
      throw error;
    });
};

// kick hoạt tài khoản
AuthService.activate = (account, activationCode) => {
  return mushroom.$auth.activateAsync(account, activationCode)
    .then(response => {
      return response;
    })
    .catch(error => {
      throw error;
    });
};

// lấy lại mật khẩu
AuthService.recoverPassword = (account) => {
  return mushroom.$auth.recoverPasswordAsync(account)
    .then(response => {
      unblockUi();
      return response;
    })
    .catch(error => {
      unblockUi();
      throw error;
    });
};

// khôi phục mật khẩu
AuthService.resetPassword = (account, code, newPassword) => {
  return mushroom.$auth.resetPasswordAsync(account, code, newPassword)
    .then(response => {
      unblockUi();
      return response;
    })
    .catch(error => {
      unblockUi();
      throw error;
    });

};

// đổi mật khẩu
AuthService.changePassword = (account, password, newPassword) => {
  return mushroom.$auth.changePasswordAsync(account, password, newPassword)
    .then(response => {
      return response;
    })
    .catch(error => {
      throw error;
    });
};


export default AuthService;
